// extracted by mini-css-extract-plugin
export default {"card-text":"EyJ_SU","card-text__grid":"v284RR","card-text__content":"iFFyCR","card-text__rich-text":"cOr20a"};